export const borderRadius = 8
export const outlinedFilled = true
export const drawerWidth = 260
export const drawerMiniWidth = 78
export const headerHeight = 72

export const transitionDuration = 200
export const pagePadding = {
  xs: '15px 10px 10px 15px',
  md: '20px 10px 20px 30px',
}
export const toolbarHeight = 70
export const miniDrawerBreakpoint = 'md'

export const CONCIERGE_TYPES = {
  WEB_WISDOM: 'Web Wisdom',
  BOOKING_LOVE: 'BookingLove',
} as const

export type ConciergeType =
  (typeof CONCIERGE_TYPES)[keyof typeof CONCIERGE_TYPES]
